<template>
  <el-row>
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="border: none">
        <i class="el-icon-card-header"></i>
        <span>诊所医生</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_2.png"/>
              </el-col>
              <el-col :span="11">
                <el-row class="numClass" style=" color: #17DEFF;">
                  <CountTo :startVal="Number(clinic.hezuozhensuo_cnt || 0) / 2"
                           :endVal="Number(clinic.hezuozhensuo_cnt || 0)"
                           :duration="changeSlow"></CountTo>
                </el-row>
                <el-row :span="24" class="hintClass">合作诊所</el-row>
              </el-col>
              <el-col :span="8" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #5DE9A8;">▲{{
                    clinic.hezuozhensuo_tongbi_ratio || ''
                  }}
                </el-row>
                <el-row :span="24" class="hintClass-small">同比</el-row>
              </el-col>
            </el-row>
            <el-row>
              <LineChart id="f3311i"
                         :show_mode="'simple'"
                         path="clinic_trend_all_cum"
                         :params="selFormFixed"
                         :area_color="'#17DEFF'"
                         height="120px"
                         width="100%"></LineChart>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_9.png"/>
              </el-col>
              <el-col :span="11">
                <el-row class="numClass" style=" color: #17DEFF;">
                  <CountTo :startVal="Number(clinic.yunzhensuo_cnt || 0) / 2"
                           :endVal="Number(clinic.yunzhensuo_cnt || 0)"
                           :duration="changeSlow"></CountTo>
                </el-row>
                <el-row :span="24" class="hintClass">云诊所</el-row>
              </el-col>
              <el-col :span="8" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #5DE9A8;">▲{{
                    clinic.yunzhensuo_tongbi_ratio || ''
                  }}({{ clinic.yunzhensuo_tongbi_cnt || 0 }})
                </el-row>
                <el-row :span="24" class="hintClass-small">同比</el-row>
              </el-col>
            </el-row>
            <el-row>
              <LineChart id="f3311i1online"
                         :show_mode="'simple'"
                         path="clinic_trend_online_cum"
                         :params="selFormFixed"
                         :area_color="'#17DEFF'"
                         height="120px"
                         width="100%"></LineChart>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_10.png"/>
              </el-col>
              <el-col :span="11">
                <el-row class="numClass" style=" color: #17DEFF;">
                  <CountTo :startVal="0.8 * Number(clinic.padzhensuo_cnt || 0)"
                           :endVal="Number(clinic.padzhensuo_cnt || 0)"
                           :duration="changeSlow"></CountTo>
                  <span class="unitClass">({{ clinic.padzhensuo_ratio || '' }})</span>
                </el-row>
                <el-row :span="24" class="hintClass">Pad诊所</el-row>
              </el-col>
              <el-col :span="8" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #5DE9A8;">▲{{
                    clinic.padzhensuo_tongbi_ratio || ''
                  }}
                </el-row>
                <el-row :span="24" class="hintClass-small">同比</el-row>
              </el-col>
            </el-row>
            <el-row>
              <LineChart id="f3311i1"
                         :show_mode="'simple'"
                         :area_color="'#17DEFF'"
                         path="clinic_trend_pad_cum"
                         :params="selFormFixed"
                         height="120px"
                         width="100%"></LineChart>
            </el-row>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="el-card-small">
            <el-row>
              <el-col :span="5" class="numClass" style="color:green">
                <img src="@/assets/admin/admin_15.png"/>
              </el-col>
              <el-col :span="12">
                <el-row class="numClass" style=" color: #17DEFF;">
                  <CountTo :startVal="0.8 * Number(clinic.doctor_cnt || 0)"
                           :endVal="Number(clinic.doctor_cnt || 0)"
                           :duration="changeSlow"></CountTo>
                </el-row>
                <el-row :span="24" class="hintClass">合作医生</el-row>
              </el-col>
              <el-col :span="7" style="margin-right: 0px">
                <el-row class="numClass-small" style="color: #5DE9A8;">男{{ clinic.doctor_male_ratio || '' }}</el-row>
                <el-row class="numClass-small" style="color: #5DE9A8;">女{{ clinic.doctor_female_ratio || '' }}</el-row>
              </el-col>
            </el-row>
            <el-row>
              <PieChart id="doctor_gender_pie11"
                        height="120px"
                        width="100%"
                        :show_mode="'simple'"
                        path="doctor_gender_pie"></PieChart>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </el-row>
</template>

<script>
import LineChart from "@/views/charts/line";
import PieChart from "@/views/charts/pie";
import CountTo from "vue-count-to";

export default {
  name: "ClinicReportSection",
  components: {
    LineChart,
    PieChart,
    CountTo,
  },
  props: {
    // 诊所/医生统计数据，保持与旧页面一致
    clinic: {
      type: Object,
      default: () => ({}),
    },
    // 计数动画时长，沿用原始业务逻辑
    changeSlow: {
      type: Number,
      default: 5000,
    },
    // 固定查询参数，供图表接口调用使用
    selFormFixed: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped src="./list.css"></style>
